import { useDispatch, useSelector } from "react-redux";
import type { RootState, AppDispatch } from "./configureStore";
import type { ResponseType } from "axios";

export interface ApiMeta {
  method: string;
  url: string;
  data?: any;
  headers?: Record<string, string>;
  responseType?: ResponseType;
  audience?: string;
}

export interface ApiAction {
  type: string;
  meta: {
    api: ApiMeta;
  };
  payload?: {
    resolve?: boolean;
  };
}

export interface ApiDispatch {
  (action: ApiAction): Promise<any>;
  <A extends { type: string }>(action: A): A;
}

export const useAppDispatch = useDispatch.withTypes<ApiDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
